import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Embed = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2ZM1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM11.8589 4.20756C10.8598 3.20838 9.23977 3.20838 8.24059 4.20756L7.17047 5.27767C6.08197 6.36618 6.08197 8.131 7.17047 9.2195C7.21953 9.26856 7.27024 9.31498 7.32241 9.35875C7.48122 9.49198 7.71225 9.46126 7.85883 9.31467L7.95054 9.22296C8.13942 9.03409 8.06646 8.70127 7.87758 8.5124C7.1796 7.81441 7.1796 6.68276 7.87758 5.98478L8.94769 4.91467C9.55635 4.30601 10.5432 4.30601 11.1518 4.91467C11.7605 5.52332 11.7605 6.51015 11.1518 7.11881L10.422 7.84868C10.2267 8.04395 10.2267 8.36053 10.422 8.55579C10.6172 8.75105 10.9338 8.75105 11.1291 8.55579L11.8589 7.82592C12.8581 6.82674 12.8581 5.20674 11.8589 4.20756ZM5.6445 7.55854C5.44924 7.36328 5.13265 7.36328 4.93739 7.55854L4.18757 8.30836C3.19945 9.29648 3.19945 10.8985 4.18757 11.8866C5.17568 12.8747 6.77773 12.8747 7.76584 11.8866L9.03777 10.6147C10.0259 9.62659 10.0259 8.02454 9.03777 7.03643L9.03173 7.03041C8.86741 6.86717 8.60534 6.89107 8.44155 7.05485L8.29517 7.20123C8.14811 7.34829 8.18361 7.59648 8.33067 7.74354C8.92825 8.34112 8.92825 9.31001 8.33067 9.90759L7.05873 11.1795C6.46114 11.7771 5.49226 11.7771 4.89467 11.1795C4.29709 10.5819 4.29709 9.61306 4.89467 9.01547L5.6445 8.26565C5.83976 8.07038 5.83976 7.7538 5.6445 7.55854Z"
      />
    </svg>
  )
})

export default Embed
